import { useState } from 'react';
import { useParams } from 'react-router-dom';
import GlobalStudentAwardsList from '../../pages/common/globalstudentawardlist';
import GlobalStudentActivityReportList from '../../pages/common/globalstudentactivityreportlist';
import GlobalStudentActivityList from '../../pages/common/globalstudentactivitylist';
import GlobalStudentAwardsReportList from '../../pages/common/globalstudentawardsreportlist'
import { Tab, Nav } from 'react-bootstrap'

const InstructorStudentActivitiesAndAwardsList = () => {
	let { slug } = useParams()
	// const { profile } = useAuth();
	const studentId = slug
	const [activeTab, setActiveTab] = useState('studendtactivities')

	return (
		<div>
			<Tab.Container defaultActiveKey="programdetails" activeKey={activeTab} onSelect={(k) => setActiveTab(k)}>
				<Nav variant="tabs">
					<Nav.Item>
						<Nav.Link eventKey="studendtactivities">Student Activities</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link eventKey="studentActivityReports">Student Activity Reports</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link eventKey="studentawards">Student Awards</Nav.Link>
					</Nav.Item>
					<Nav.Item>
						<Nav.Link eventKey="studentAwardsReports">Student Awards Reports</Nav.Link>
					</Nav.Item>
				</Nav>
				<Tab.Content>
					<Tab.Pane eventKey="studendtactivities">
						<GlobalStudentActivityList slug={slug} isStudent={false} studentRole={'Student12'} />
					</Tab.Pane>
					<Tab.Pane eventKey="studentActivityReports">
						<GlobalStudentActivityReportList studentId={studentId} />
					</Tab.Pane>
					<Tab.Pane eventKey="studentawards">
						<GlobalStudentAwardsList slug={slug} isStudent={false} studentRole={'Student12'} />
					</Tab.Pane>
					<Tab.Pane eventKey="studentAwardsReports">
						<GlobalStudentAwardsReportList studentId={studentId} />
					</Tab.Pane>
				</Tab.Content>
			</Tab.Container>
		</div>
	)
}

export default InstructorStudentActivitiesAndAwardsList;
